import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { GlobalLoadingQuery } from '../../state/global-loading/global-loading.query';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

/**
 * ✅ Global Loading Spinner Component (Akita-based)
 * Replaces ngx-spinner with clean Akita state management
 */
@Component({
  selector: 'app-global-loading-spinner',
  templateUrl: './global-loading-spinner.component.html',
  styleUrls: ['./global-loading-spinner.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinner, AsyncPipe],
})
export class GlobalLoadingSpinnerComponent {
  private loadingQuery = inject(GlobalLoadingQuery);

  // Observables from Akita query
  isLoading$ = this.loadingQuery.isLoading$;
  message$ = this.loadingQuery.message$;
}
